module.exports = __webpack_public_path__ + "static/AnteriorCore-CoreHold-7c2238ef812aaa2057af5eb7feb15add.mp4";